export default __webpack_public_path__ + "static/media/Give_us_a_light.4fc59358.mp3";